import { render, staticRenderFns } from "./EmailAttachments.vue?vue&type=template&id=a15a12d8&"
import script from "./EmailAttachments.vue?vue&type=script&lang=js&"
export * from "./EmailAttachments.vue?vue&type=script&lang=js&"
import style0 from "./EmailAttachments.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports